var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFreshsales = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B65C3",
    fillRule: "evenodd",
    d: "M4.681 22.296a15.57 15.57 0 0 0 4.351 8.642l5.288-5.288c0-5.348 2.78-10.545 7.735-13.415L4.68 22.296Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE63C5",
    fillRule: "evenodd",
    d: "m14.32 25.65-5.288 5.288c2.296 2.296 5.288 3.867 8.642 4.35l10.03-17.373c-2.84 4.955-8.036 7.735-13.384 7.735",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF63C6",
    fillRule: "evenodd",
    d: "M16.405 33.415a15.34 15.34 0 0 1-2.085-7.735l-5.288 5.288c2.296 2.296 5.288 3.867 8.642 4.35a21 21 0 0 1-1.27-1.903Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3278B1",
    fillRule: "evenodd",
    d: "m34.02 5.346-11.935 6.92c-4.955 2.87-10.847 2.658-15.47 0A15.3 15.3 0 0 0 4.53 20c0 .786.06 1.54.181 2.296.605.484 1.24.907 1.904 1.3a15.34 15.34 0 0 0 7.735 2.084L34.352 5.678c-.121-.12-.212-.241-.333-.332Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3278B2",
    fillRule: "evenodd",
    d: "M6.585 23.596a15.34 15.34 0 0 0 7.735 2.084c0-5.348 2.78-10.544 7.735-13.415L4.65 22.296c.635.454 1.27.907 1.934 1.3Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#45A4EC",
    fillRule: "evenodd",
    d: "M6.585 12.265A15.3 15.3 0 0 0 4.5 20c0 .786.06 1.54.181 2.296l17.404-10.03a15.59 15.59 0 0 1-15.5 0Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#19BB7D",
    fillRule: "evenodd",
    d: "M34.352 5.648a3 3 0 0 0-.333-.302 2.7 2.7 0 0 0-.483-.332 3.85 3.85 0 0 0-1.934-.514H20c-5.74 0-10.726 3.112-13.415 7.735 4.623 2.659 10.514 2.87 15.47 0A15.49 15.49 0 0 0 14.32 25.65c5.348 0 10.544-2.78 13.415-7.735l6.889-11.934a3 3 0 0 0-.272-.333",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#08C7FB",
    fillRule: "evenodd",
    d: "m22.085 12.265 11.934-6.889a2.7 2.7 0 0 0-.483-.332L6.585 12.265a15.59 15.59 0 0 0 15.5 0",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#59F2F6",
    fillRule: "evenodd",
    d: "M31.602 4.5H20c-5.74 0-10.726 3.112-13.415 7.735l26.951-7.221c-.574-.303-1.209-.514-1.934-.514",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA3757",
    fillRule: "evenodd",
    d: "m27.735 17.915 6.889-11.934a3 3 0 0 0-.302-.333L14.32 25.65c0 2.629.664 5.288 2.084 7.735.393.665.816 1.3 1.3 1.904a15.27 15.27 0 0 0 10.031-1.904c-2.659-4.623-2.87-10.515 0-15.47",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D33C4E",
    fillRule: "evenodd",
    d: "M14.32 25.65c0 2.629.664 5.288 2.084 7.735.393.665.816 1.3 1.3 1.904l10.03-17.374A15.49 15.49 0 0 1 14.32 25.65",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5A24",
    fillRule: "evenodd",
    d: "M27.735 17.915 17.704 35.32a15.27 15.27 0 0 0 10.031-1.904c-2.659-4.653-2.87-10.545 0-15.5Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BDF55",
    fillRule: "evenodd",
    d: "M34.956 6.464a2.7 2.7 0 0 0-.332-.483 3 3 0 0 0-.302-.333 3 3 0 0 0-.333-.302l-11.904 6.92A15.49 15.49 0 0 0 14.35 25.68c5.348 0 10.545-2.78 13.415-7.735-2.87 4.956-2.659 10.847 0 15.47C32.388 30.726 35.5 25.741 35.5 20V8.398c-.03-.725-.212-1.39-.544-1.934",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#25C16F",
    fillRule: "evenodd",
    d: "m34.02 5.346-11.935 6.92A15.49 15.49 0 0 0 14.35 25.68L34.352 5.678c-.121-.12-.212-.241-.333-.332Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#8BDF55",
    fillRule: "evenodd",
    d: "M14.32 25.65c5.348 0 10.544-2.78 13.415-7.735l6.889-11.934a3 3 0 0 0-.302-.333z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB0",
    fillRule: "evenodd",
    d: "m34.624 5.98-6.89 11.935c-2.87 4.955-2.658 10.847 0 15.47l7.222-26.951a4 4 0 0 0-.332-.453Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA800",
    fillRule: "evenodd",
    d: "M27.735 33.415C32.358 30.726 35.47 25.741 35.47 20V8.398c0-.695-.181-1.36-.514-1.934z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFreshsales);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/freshsales.ec1d7d9e.svg";